module.exports = __webpack_public_path__ + "assets/b42.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b42.png
// module id = 630
// module chunks = 0